module.exports = __webpack_public_path__ + "media/images/e-bilet/arrow_down-90437a04f71bd512522b6b0315c6ba41.svg";